import ModalConfirmation from "../../app/components/ModalConfirmation.vue"

interface ModalOptions {
    title?: string
    description?: string
    color?: "primary" | "error" | "success" | "info" | "warning" | "neutral"
    // eslint-disable-next-line
    onConfirmFn: (() => Promise<any> | any)
    // eslint-disable-next-line
    onCancelFn?: (() => Promise<any> | any) | undefined
    // eslint-disable-next-line
    onDismissFn?: (() => Promise<any> | any) | undefined
    confirmButtonText?: string
    cancelButtonText?: string
}

export const useConfirmation = defineStore('confirmation', () => {
    // eslint-disable-next-line
    const modals = reactive<{[key: string]: any}>({})

    const getModals = () => modals

    const getModal = (key: string) => {
        return getModals()[key]
    }

    const createModal = (key: string, options?: ModalOptions) => {
        const modal = useOverlay().create(ModalConfirmation, {
            props: {
                title: options?.title, 
                description: options?.description, 
                color: options?.color || 'primary', 
                buttonConfirmText: options?.confirmButtonText || 'Подтвердить', 
                buttonCancelText: options?.cancelButtonText || 'Отменить', 
                'onConfirm': async () => await confirm(key, options?.onConfirmFn),
                'onCancel': async () => await cancel(key, options?.onCancelFn),
                'onDismiss': () => { hideModal(key); options?.onDismissFn?.() }
            } 
        })
        modals[key] = modal
    }

    const copyModal = (refKey: string, key: string, options?: Partial<ModalOptions>) => {
        const originalModal = getModal(refKey)
        if (originalModal) {
            const originalProps = originalModal.props
            createModal(key, {
                ...originalProps,
                ...options,
            })
        }
    }

    const showModal = (key: string) => {
        modals[key].open()
    }

    const hideModal = (key: string) => {
        modals[key].close()
    }
    
    const confirm = async (key: string, confirmFn: () => Promise<void> | void = async () => { }) => {
        hideModal(key)
        if (confirmFn) await confirmFn()
    }

    const cancel = async (key: string, cancelFn: () => Promise<void> | void = async () => { }) => {
        hideModal(key)
        if (cancelFn) await cancelFn()
    }

    return {
        // actions
        getModals,
        getModal,
        createModal,
        copyModal,
        showModal,
        confirm,
        cancel,
    };
});